import {useReducer} from 'react';

import {AppRatesContext} from './AppRatesContext';
import type {
  AppRatesAction,
  AppRatesProviderProps,
  AppRatesState,
} from './types';
import {AppRatesType} from './types';

const getAppRatesReducer = (state: AppRatesState, action: AppRatesAction) => {
  switch (action.type) {
    case AppRatesType.GET_RATES:
      return {
        ...state,
        ...action.payload,
      };

    case AppRatesType.GET_BUSINESS_RATES:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

const initialState = {
  loading: false,
  rawAppRates: [],
  businessRateList: [],
  businessRates: {},
  businessRateListLoading: false,
  appRates: {},
  otcVolume: [],
};

export const AppRatesProvider = ({children}: AppRatesProviderProps) => {
  const [state, dispatch] = useReducer(getAppRatesReducer, initialState);

  return (
    <AppRatesContext.Provider value={{state, dispatch}}>
      {children}
    </AppRatesContext.Provider>
  );
};
